import { Endpoint } from '@/types/api.type.ts';

export const complectationEndpoints: Endpoint[] = [
    {
        name: 'getComplectations',
        method: 'get',
        path: '/complectations',
    },
    {
        name: 'getComplectation',
        method: 'get',
        path: '/complectations/:id',
    },
    {
        name: 'createComplectation',
        method: 'post',
        path: '/complectations',
    },
    {
        name: 'updateComplectation',
        method: 'patch',
        path: '/complectations/:id',
    },
    {
        name: 'deleteComplectation',
        method: 'delete',
        path: '/complectations/:id',
    },
    {
        name: 'getComplectationsByModelId',
        method: 'get',
        path: '/complectations/all-by-model/:id',
    },
];
